import { render } from "./DashaTable.vue?vue&type=template&id=d20afcc2"
import script from "./DashaTable.vue?vue&type=script&lang=js"
export * from "./DashaTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__